import CampaignSurveyPanel from './campaignSurveyPanel.container';

export default CampaignSurveyPanel;